import React from 'react'

const Contact = () => {
    return (
        <div>
            <div class="my-5">
                <div class="text-center">
                    <h1>Contact Us</h1>
                </div>
                <div class="container contact_div text-muted">
                    <div class="row">
                        <div class="col-md-6 col-10 mx-auto">
                            <form>
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1" class="form-label">Full Name</label>
                                    <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="enter your name" />
                                </div>
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1" class="form-label">Phone Number</label>
                                    <input type="number" class="form-control" id="exampleFormControlInput1" placeholder="enter your phone number" />
                                </div>
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1" class="form-label">Email address</label>
                                    <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com" />
                                </div>
                                <div class="mb-3">
                                    <label for="exampleFormControlTextarea1" class="form-label">Example textarea</label>
                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                </div>
                            </form>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
